<template>
  <div>
    <v-alert
      v-if="!loading && reviewsPackage.type == 'trial'"
      type="info"
      icon="timelapse"
      class="py-0 mb-4"
      mb-4
      prominent
      text
      dense
      >
      <v-row align="center">
        <v-col class="grow"><strong>Proefperiode</strong> van Reviews  is actief voor {{ activeCompData.name }}. </v-col>
        <v-col class="shrink">
          <v-btn
            color="info"
            outlined
            >
             Nog {{ reviewsPackage.days }} <span style="color: #2196f3" v-if="reviewsPackage.days == 1" >dag</span><span style="color: #2196f3" v-else>dagen</span>
          </v-btn>
        </v-col>
      </v-row>
    </v-alert>

    <div v-if="!loading && companies.length > 1 && !demoMode" class="pt-2">
      <v-container grid-list-md class="pa-0" fluid>
        <v-layout row wrap>
          <v-flex md3 xs12>
            <v-select
              v-if="!loading && companies.length > 1"
              :items="filteredCompanies"
              :item-color="companyPrimaryColor"
              background-color="menu"
              item-text="name"
              item-value="id"
              v-on:input="loadActiveCompData()"
              v-model="activeComp"
              no-data-text="Geen bedrijven gevonden."
              label="Selecteer bedrijf"
              outlined
              dense>
              <template v-slot:prepend-item>
                <v-list-item>
                  <v-list-item-content  class="pt-0" >
                    <v-text-field
                      :color="companyPrimaryColor"
                      placeholder="Zoeken"
                      prepend-inner-icon="search"
                      clearable
                      v-model="searchCompanies"
                      hide-details=""
                      dense
                    ></v-text-field>
                  </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>
                <div v-if="searchCompanies && searchCompanies.length > 0" style="padding: 4px 17px 3px 17px; background-color:rgba(0,0,0, 0.02); color: rgba(0, 0, 0, 0.6); text-align: center; font-size: 12px">{{ filteredCompanies.length }} van {{ companies.length }} bedrijven</div>
                <v-divider v-if="searchCompanies && searchCompanies.length > 0"></v-divider>
              </template>
            </v-select>
          </v-flex>
        </v-layout>
      </v-container>
    </div>

    <div v-if="loading" class="blackbox-loader"></div>

    <div v-else class="special-content-box">
      <tabs :options="{ useUrlFragment: false }">

        <tab name="Algemeen" v-if="userRole == 'superadmin' || userRole == 'admin'" class="first">
          <div v-if="loading == false" class="tab-inner-wrapper padding">
            <div class="tab-content">
              <v-container grid-list-md class="pa-0" fluid>
                <v-layout row wrap>
                  <v-flex md6 xs12>
                    <h1 class="tab-title">Algemene instellingen</h1>
                    <p>Algemene instellingen voor Reviews</p>
                  </v-flex>
                  <v-flex md6 xs12>
                    <div style="display: inline-block; float: right;">
                      <v-btn rounded :color="companySecondaryColor" class="modal-button-next" :dark="changed" :disabled="!changed" :depressed="!changed" @click="updateCompanyEmail()">Wijzigingen opslaan<v-icon right dark>chevron_right</v-icon></v-btn>
                    </div>
                  </v-flex>
                </v-layout>
              </v-container>
              
              <div class="tab-item">
                <div class="tab-item-intro">
                  <h3>Digital bon instellingen</h3>
                  <p></p>
                </div>
                <div class="tab-item-field">
                  <v-switch
                    class="ma-0 pa-0"
                    label="Digitale bon verzenden"
                    v-model="activeCompData.receipt.sendReceipt"
                    :color="companyPrimaryColor"
                    hint="Digital bon wordt maximaal 5 minuten na afrekenen van de klant verzonden."
                    persistent-hint
                  ></v-switch>
                </div>
                <div class="tab-item-field">
                  <v-switch
                    class="ma-0 pa-0"
                    label="Review vraag meesturen in de digitale bon"
                    v-model="activeCompData.receipt.sendReceiptJourney"
                    :color="companyPrimaryColor"
                    hint="Let op! Reviews worden niet meer los verzonden naar de klant maar gecombineerd met de digitale bon."
                    persistent-hint
                  ></v-switch>
                </div>
              </div>

              <div class="tab-item">
                <div class="tab-item-intro">
                  <h3>Review instellingen</h3>
                </div>

                <div class="survey-items-wrapper">
                  <h3>Verzendadres en website</h3>
                  <p>De review wordt vanuit dit adres verzonden. Het logo linkt naar de website URL</p>
                </div>

                <div class="tab-item-field">
                  <v-text-field
                    style="max-width: 400px"
                    outlined
                    :color="companyPrimaryColor"
                    label="E-mailadres"
                    v-model="activeCompData.email"
                    background-color="background"
                    autocomplete
                    prepend-inner-icon="email"
                    hint="Met dit emailadres zal de review verzonden worden. Deze is zichtbaar in de inbox van de ontvanger."
                    persistent-hint
                    ></v-text-field>
                </div>
                <div class="tab-item-field">
                  <v-text-field
                    style="max-width:400px"
                    outlined
                    :color="companyPrimaryColor"
                    label="Website URL"
                    background-color="background"
                    v-model="activeCompData.url"
                    autocomplete
                    prepend-inner-icon="web"
                    hint="Na het invullen van de review zal de ontvanger naar deze website verzonden worden."
                    persistent-hint
                    ></v-text-field>
                </div>
              </div>

              <div class="tab-item">
                <div class="survey-items-wrapper">
                  <h3>Verzendings instellingen</h3>
                  <p>Hoe vaak mag een persoon maximaal gemaild worden? Je kan dit beperken en zelf een maximale periode instellen.</p>
                </div>
                <div class="api-switch-wrapper">
                  <v-switch
                    label="Minimale periode tussen 2 review's instellen"
                    v-model="activeCompData.sendRestriction"
                    :color="companyPrimaryColor"
                  ></v-switch>
                  <div class="tab-item-select" v-if="activeCompData.sendRestriction == true">
                    <v-select
                      outlined
                      :color="companyPrimaryColor"
                      :item-color="companyPrimaryColor"
                      class="pa-0 ma-0"
                      v-model="activeCompData.sendRestrictionTime"
                      background-color="background"
                      :items="sendRestrictions"
                      item-text="label"
                      item-value="time"
                      hide-details
                      label="Selecteer minimale periode"
                    ></v-select>
                  </div>
                </div>
              </div>

              <div class="tab-item">
                <div class="tab-item-intro">
                  <h3>DirectFeedback</h3>
                  <p>Gelijk een mail ontvangen als een klant een slechte ervaring heeft? Je kan dit aanzetten en een minimum score instellen.</p>
                </div>
                <div class="api-switch-wrapper">
                  <v-switch
                    label="Ik wil bericht ontvangen bij een slechte beoordeling"
                    v-model="activeCompData.directFeedback"
                    :color="companyPrimaryColor"
                  ></v-switch>
                  <div class="tab-item-select" v-if="activeCompData.directFeedback == true">
                    <v-select
                      outlined
                      :color="companyPrimaryColor"
                      :item-color="companyPrimaryColor"
                      v-model="activeCompData.directFeedbackScore"
                      :items="minimumScore"
                      background-color="background"
                      item-text="label"
                      item-value="score"
                      label="Bericht ontvangen bij deze beoordeling."
                    ></v-select>

                    <v-text-field
                      style="max-width:400px"
                      outlined
                      :color="companyPrimaryColor"
                      label="E-mailadres ontvanger"
                      v-model="activeCompData.directFeedbackMailTo"
                      background-color="background"
                      autocomplete
                      prepend-inner-icon="email"
                      hint="DirectFeedback verzenden naar dit e-mailadres."
                      persistent-hint
                      ></v-text-field>

                    <v-text-field
                      style="max-width:400px"
                      outlined
                      :color="companyPrimaryColor"
                      label="E-mailadres verzender"
                      background-color="background"
                      v-model="activeCompData.directFeedbackMailFrom"
                      autocomplete
                      prepend-inner-icon="email"
                      hint="DirectFeedback verzenden vanaf dit e-mailadres."
                      persistent-hint
                      ></v-text-field>
                  </div>
                </div>
              </div>

              <div class="tab-item">
                <div class="tab-item-intro">
                  <h3>Maximale reactietijd op reviewmail</h3>
                  <p>Hoe lang heeft een persoon de tijd om vragen uit de review te beantwoorden?</p>
                </div>

                <div class="tab-item-select">
                  <v-select                   
                    outlined
                    :color="companyPrimaryColor"
                    :item-color="companyPrimaryColor"
                    v-model="activeCompData.surveyResponseTime"
                    :items="responseRestrictions"
                    background-color="background"
                    item-text="label"
                    item-value="time"
                    label="Selecteer maximale periode"
                    hide-details
                  ></v-select>
                </div>
              </div>

              <div class="tab-item">
                <div class="tab-item-intro">
                  <h3>Vraag feedback bij beoordeling</h3>
                  <p>Vraag direct om feedback na het geven van een score</p>
                </div>

                <div class="tab-item-select">
                  <v-select
                    outlined
                    :color="companyPrimaryColor"
                    :item-color="companyPrimaryColor"
                    v-model="activeCompData.surveyFeedbackAsk"
                    :items="minimumScore"
                    background-color="background"
                    item-text="label"
                    item-value="score"
                    label="Om feedback vragen vanaf deze score en lager"
                    hide-details
                  ></v-select>
                </div>
              </div>

              <div class="tab-item last">
                <div class="tab-item-intro">
                  <h3>Beoordelingsweergave</h3>
                  <p>Kies de weergave die zal worden getoond aan de ontvanger van de review.</p>
                </div>
                <div class="tab-item-field">
                  <div class="rating-view-wrapper">
                    <v-radio-group v-model="activeCompData.ratingView">
                      <div>
                        <v-radio label="Smileys" value="smileys" :color="companyPrimaryColor"></v-radio>
                        <div class="smiley-example"></div>
                        <p>Smileys kunnen gebruikt worden om de emotie van de klant beter aan te spreken.</p>
                      </div>
                      <div>
                        <v-radio label="Stars" value="stars" :color="companyPrimaryColor"></v-radio>
                        <div class="stars-example"></div>
                      </div>
                    </v-radio-group>
                  </div>
                </div>
              </div>
              <div class="survey-page-button clear">
                <v-btn round dark :color="companySecondaryColor" class="modal-button-next" v-if="(activeCompData.directFeedback != activeCompDataOriginal.directFeedback) || (activeCompData.receipt.sendReceipt != activeCompDataOriginal.receipt.sendReceipt) || (activeCompData.receipt.sendReceiptJourney != activeCompDataOriginal.receipt.sendReceiptJourney)|| (activeCompData.surveyFeedbackAsk != activeCompDataOriginal.surveyFeedbackAsk)|| (activeCompData.directFeedbackScore != activeCompDataOriginal.directFeedbackScore) || (activeCompData.directFeedbackMailTo != activeCompDataOriginal.directFeedbackMailTo) || (activeCompData.directFeedbackMailFrom != activeCompDataOriginal.directFeedbackMailFrom) || (activeCompData.sendRestrictionTime != activeCompDataOriginal.sendRestrictionTime) || (activeCompData.surveyResponseTime != activeCompDataOriginal.surveyResponseTime) || (activeCompData.sendRestriction != activeCompDataOriginal.sendRestriction) || (activeCompData.email != activeCompDataOriginal.email) || (activeCompData.url != activeCompDataOriginal.url) || (activeCompData.ratingView != activeCompDataOriginal.ratingView)" @click="updateCompanySettings()">Wijzigingen opslaan<v-icon right dark>arrow_forward_ios</v-icon></v-btn>
              </div>
            </div>
          </div>
        </tab>

        <tab name="E-mail" v-if="userRole == 'superadmin' || userRole == 'admin'">
          <div v-if="loading == false" class="tab-inner-wrapper padding">
            <v-container grid-list-md class="pa-0" fluid>
              <v-layout row wrap>
                <v-flex md6 xs12>
                  <h1 class="tab-title">Email instellingen</h1>
                  <p>Personaliseer de teksten die de respondenten te zien kijken in de email die verzonden wordt. </p>
                </v-flex>
                <v-flex md6 xs12>
                  <div style="display: inline-block; float: right;">
                    <v-btn rounded :color="companySecondaryColor" class="modal-button-next" :dark="changed" :disabled="!changed" :depressed="!changed" @click="updateCompanyEmail()">Wijzigingen opslaan<v-icon right dark>chevron_right</v-icon></v-btn>
                  </div>
                </v-flex>
              </v-layout>
            </v-container>
            <!-- <div class="test-mail-wrapper">
                <button @click="openTestmailDialog()">Verstuur test email</button>
              </div> -->
            <div  class="select-language-wrapper clear" v-if="activeCompData.languages.length > 1">
              <div class="select-language-flag">
                <div v-if="selectedLanguage == 'en'" class="language-flag uk"></div>
                <div v-if="selectedLanguage == 'nl'" class="language-flag nl"></div>
              </div>
              <div class="select-language-input">
                <v-select
                  outlined
                  :color="companyPrimaryColor"
                  :item-color="companyPrimaryColor"
                  v-model="selectedLanguage"
                  background-color="background"
                  :items="languages"
                  label="Selecteer taal"
                  item-text="name"
                  item-value="code"
                ></v-select>
              </div>
            </div>

            <div class="email-preview-wrapper">
              <div class="tab-item-field">
                <div v-if="selectedLanguage == 'nl'">
                <v-text-field
                  outlined
                  :color="companyPrimaryColor"
                  label="Onderwerp"
                  v-model.trim="activeCompData.emailSubject.nl"
                  background-color="background"
                  counter="65"
                  maxlength="65"
                ></v-text-field>
              </div>
              <div v-if="selectedLanguage == 'en'">
                <v-text-field
                  outlined
                  :color="companyPrimaryColor"
                  label="Subject"
                  v-model.trim="activeCompData.emailSubject.en"
                  counter="65"
                  maxlength="65"
                ></v-text-field>
                </div>
              </div>
              <div class="email-preview" :style="{backgroundColor: $vuetify.theme.themes[theme].background}">
                <div class="email-wrapper" :style="{backgroundColor: $vuetify.theme.themes[theme].menu, borderColor: $vuetify.theme.themes[theme].menuborder}">
                  <div class="email-logo">
                    <img :src="activeCompData.logoUrl">
                  </div>
                  <h2 v-if="selectedLanguage == 'nl'">Beste % klantnaam %</h2>
                  <h2 v-if="selectedLanguage == 'en'">Dear % clientname %</h2>
                  <div class="email-text" v-if="selectedLanguage == 'nl'">
                    <wysiwyg  v-model.trim="activeCompData.emailIntro.nl" />
                  </div>
                  <div class="email-text" v-if="selectedLanguage == 'en'">
                    <wysiwyg  v-model.trim="activeCompData.emailIntro.en" />
                  </div>
                  <div class="rating-preview-wrapper">
                    <h2>% Willekeurige vraag uit de review %</h2>
                    <div v-if="activeCompData.ratingView == 'smileys'" class="rating-preview-smileys clear">
                      <div class="preview-smiley smiley-one"></div>
                      <div class="preview-smiley smiley-two"></div>
                      <div class="preview-smiley smiley-three"></div>
                      <div class="preview-smiley smiley-four"></div>
                      <div class="preview-smiley smiley-five"></div>
                    </div>
                    <div v-if="activeCompData.ratingView == 'stars'" class="rating-preview-stars clear">
                      <div class="preview-star star-one"></div>
                      <div class="preview-star star-two"></div>
                      <div class="preview-star star-three"></div>
                      <div class="preview-star star-four"></div>
                      <div class="preview-star star-five"></div>
                    </div>
                  </div>

                </div>
                <div class="social-preview-wrapper">
                    <p>
                      <a v-if="activeCompData.social.facebook == true" :href="activeCompData.social.facebookUrl" target="_blank" class="social-icon-preview facebook"> </a>
                      <a v-if="activeCompData.social.instagram == true" :href="activeCompData.social.instagramUrl" target="_blank" class="social-icon-preview instagram"> </a>
                      <a v-if="activeCompData.social.pinterest == true" :href="activeCompData.social.pinterestUrl" target="_blank" class="social-icon-preview pinterest"> </a>
                      <a v-if="activeCompData.social.twitter == true" :href="activeCompData.social.twitterUrl" target="_blank" class="social-icon-preview twitter"> </a>
                      <a v-if="activeCompData.social.googleplus == true" :href="activeCompData.social.googleplusUrl" target="_blank" class="social-icon-preview googleplus"> </a>
                    </p>
                  </div>
                  <div class="preview-footer">
                    <p v-if="selectedLanguage == 'nl'">Afmelden</p>
                    <p v-if="selectedLanguage == 'en'">Unsubscribe</p>
                  </div>
    
              </div>

            </div>
          </div>
        </tab>

        <tab name="Pagina" v-if="userRole == 'superadmin' || userRole == 'admin'">
          <div v-if="loading == false" class="tab-inner-wrapper padding">
            <div v-if="activeCompData" class="edit-survey-page-text" >
              <v-container grid-list-md class="pa-0" fluid>
              <v-layout row wrap>
                <v-flex md6 xs12>
                  <h1 class="tab-title">Pagina instellingen</h1>
                  <p>Personaliseer de teksten die de respondenten te zien krijgen op deze pagina.</p>
                </v-flex>
                <v-flex md6 xs12>
                  <div style="display: inline-block; float: right;">
                    <v-btn rounded :color="companySecondaryColor" class="modal-button-next" :dark="changed" :disabled="!changed" :depressed="!changed" @click="updateCompanySurveyPage()">Wijzigingen opslaan<v-icon right dark>chevron_right</v-icon></v-btn>
                  </div>
                </v-flex>
              </v-layout>
            </v-container>
      

              <div  class="select-language-wrapper clear" v-if="activeCompData.languages.length > 1">
                <div class="select-language-flag">
                  <div v-if="selectedLanguage == 'en'" class="language-flag uk"></div>
                  <div v-if="selectedLanguage == 'nl'" class="language-flag nl"></div>
                </div>

                <div class="select-language-input">
                  <v-select
                    outlined
                    :color="companyPrimaryColor"
                    :item-color="companyPrimaryColor"
                    v-model="selectedLanguage"
                    :items="languages"
                    label="Selecteer taal"
                    item-text="name"
                    item-value="code"
                  ></v-select>
                </div>
              </div>

                  <!-- begin questions laden --> 
                <div class="survey-background" style="background-color: #f6f7fb; margin: 20px 0 0 0; padding: 50px 0;" :style="{backgroundColor: $vuetify.theme.themes[theme].background}">
                  <div class="survey-wrapper" style="margin-top: 0;" :style="{backgroundColor: $vuetify.theme.themes[theme].menu, borderColor: $vuetify.theme.themes[theme].menuborder}">
                    <a :href="activeCompData.url" target="_blank" class="survey-logo-client">
                      <v-img aspect-ratio="1" :src="activeCompData.logoUrl">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height ma-0"
                            align="center"
                            justify="center"
                          >
                            <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </a>
                    <v-form>
                      <div class="field-wrapper" style="margin: 0 0 20px 0;" >
                        <label style="display: none;"  class="settings-form-label">Introtekst responsepagina</label>
                        <wysiwyg v-if="selectedLanguage == 'nl'" v-model.trim="activeCompData.pageIntro.nl" />
                        <wysiwyg v-if="selectedLanguage == 'en'" v-model.trim="activeCompData.pageIntro.en" />
                      </div>
                      <div class="field-wrapper">
                        <label style="display: none;" class="settings-form-label">Introtekst om andere aspecten te beoordelen</label>
                        <wysiwyg v-if="selectedLanguage == 'nl'" v-model.trim="activeCompData.pageAspects.nl" />
                        <wysiwyg v-if="selectedLanguage == 'en'" v-model.trim="activeCompData.pageAspects.en" />
                      </div>
                    </v-form>
                    <div >
                      <v-select
                        class="mt-4"
                        outlined
                        :color="companyPrimaryColor"
                        :item-color="companyPrimaryColor"
                        :items="journeys"
                        item-text="name"
                        item-value="id"
                        label="Selecteer een journey"
                        v-on:input="loadQuestions()"
                        v-model="selectedJourneyId"
                        >
                      ></v-select> 
                    </div>
                    <div v-if="this.questions.length > 0">
                    <div class="score-wrapper">
                      <p :style="{color: $vuetify.theme.themes[theme].text}" v-if="selectedLanguage == 'nl'"><b>Gemiddelde score</b></p>
                      <p :style="{color: $vuetify.theme.themes[theme].text}" v-else><b>Average score</b></p>
                      <p :style="{color: $vuetify.theme.themes[theme].text}" class="average-score">{{ averageScore }}</p>
                    <div class="extra-survey-wrapper" v-if="dataLeft > 0">
                      <p class="extra-survey-intro-header" v-if="selectedLanguage == 'nl'">
                        <span :style="{color: $vuetify.theme.themes[theme].text}" v-if="dataLeft == 1">{{ dataLeft }} ander aspect beoordelen?</span>
                        <span :style="{color: $vuetify.theme.themes[theme].text}" v-if="dataLeft > 1">{{ dataLeft }} andere aspecten beoordelen?</span>
                      </p>
                      <p class="extra-survey-intro-header" v-else>
                        <span :style="{color: $vuetify.theme.themes[theme].text}" v-if="dataLeft == 1">Evaluate {{ dataLeft }} other aspect?</span>
                        <span :style="{color: $vuetify.theme.themes[theme].text}" v-if="dataLeft > 1">Evaluate {{ dataLeft }} other aspects?</span>
                      </p>
                      <p :style="{color: $vuetify.theme.themes[theme].text}" v-if="selectedLanguage == 'nl'" v-html="activeCompData.pageAspects.nl"></p>
                      <p :style="{color: $vuetify.theme.themes[theme].text}" v-else v-html="activeCompData.pageAspects.en"></p>
                    </div>

                      <div class="survey-items-wrapper text-center" v-for="(question) in questions" :key="question.order" >
                        <div class="survey-item" :class="{ selected : question.rating }"  v-if="!question.answered && question.type == 'rating'" :style="{borderColor: $vuetify.theme.themes[theme].menuborder}" >
                          <div class="text-center"> 
                            <h2 :style="{color: $vuetify.theme.themes[theme].text}"  v-if="selectedLanguage == 'nl'">{{question.question.nl}}</h2>
                            <h2 :style="{color: $vuetify.theme.themes[theme].text}"  v-if="selectedLanguage == 'en'">{{question.question.en}}</h2>
                          </div>
                          <div class="icon-wrapper clear">
                            <v-radio-group  v-model="question.rating" :mandatory="false" @click="ratingSum()">
                              <a class="rating-icon rating-slecht" :class="'rating-' + question.rating"><v-radio label="slecht" value=1></v-radio></a>
                              <a class="rating-icon rating-onvoldoende" :class="'rating-' + question.rating"><v-radio label="onvoldoende" value=2></v-radio></a>
                              <a class="rating-icon rating-voldoende" :class="'rating-' + question.rating"><v-radio label="matig" value=3></v-radio></a>
                              <a class="rating-icon rating-goed" :class="'rating-' + question.rating"><v-radio label="voldoende" value=4></v-radio></a>
                              <a class="rating-icon rating-super" :class="'rating-' + question.rating"><v-radio label="goed" value=5></v-radio></a>
                            </v-radio-group>
                          </div>
                          
                          <div class="feedback-option" v-if="question.rating <= activeCompData.surveyFeedbackAsk" >
                            <div class="feedback-option-label">
                              <span v-if="question.rating < 4 && question.rating <= activeCompData.surveyFeedbackAsk">
                                <span v-if="selectedLanguage == 'nl'">Wat hadden wij beter kunnen doen?</span>
                                <span v-else>What could we have done better?</span>
                              </span>
                              <span v-if="question.rating == 4 && question.rating <= activeCompData.surveyFeedbackAsk">
                                <span v-if="selectedLanguage == 'nl'">Wat kunnen we nog verbeteren?</span>
                                <span v-else>What can we improve?</span>
                              </span>
                              <span v-if="question.rating == 5 && question.rating <= activeCompData.surveyFeedbackAsk">
                                <span v-if="selectedLanguage == 'nl'">Wat vond je zo geweldig?</span>
                                <span v-else>What did you love so much?</span>
                              </span>
                            </div>

                            <textarea :style="{background: $vuetify.theme.themes[theme].background}" placeholder="Schrijf hier je feedback..." v-model="question.feedback"></textarea>
                          </div>
                        </div>
                      </div>
                    <div class="survey-footer"><p :style="{color: $vuetify.theme.themes[theme].text}">{{ activeCompData.name }} &#9400;</p></div> 
                  </div>
                  <v-btn class="send-survey-button-page-preview" fixed rounded dark :color="activeCompData.colors.primary.hex">Feedback versturen <span v-if="averageScore > 0" class="average-score-button">({{ averageScore }})</span><v-icon>chevron_right</v-icon></v-btn>

                  </div>
                    <div v-else>
                      <div style="color: #8B93A6; margin: 50px 0 70px 0; padding: 0 15px; font-style: italic;" class="text-xs-center pt-2"> De geselecteerde journey bevat geen vragen. Voeg vragen toe op de 
                        <router-link :to="`/journeys`" custom v-slot="{ navigate }"><a @click="navigate">Journey pagina</a></router-link>.</div>
                    </div>
                </div>
              </div>

            </div>
          </div>
        </tab>

      </tabs>
    </div>

    <!-- / Test Email Dialog \ -->
    <v-dialog v-model="testEmail.dialog" max-width="600px">
      <v-card v-if="testEmail.dialog">
        <div class="hogans-modal-header" v-bind:style="{ backgroundColor: companyPrimaryColor}">
          <h2>Testmail verzenden</h2>
          <div class="hogans-modal-header-close" @click="testEmail.dialog = false"></div>
        </div>
          <v-alert
            class="ma-0 pa-2"
            v-if="testEmail.feedback"
            :value="true"
            type="warning"
          >
          {{ testEmail.feedback }} 
          </v-alert>
        <v-divider></v-divider>
        <v-card-text>
          <v-form ref="testmail">
            <v-select
              v-if="activeCompData.languages.length > 1"
              v-model="testEmail.language"
              :items="languages"
              prepend-icon="flag"
              label="Taal"
              item-text="name"
              item-value="code"
              required
            ></v-select>
            <v-text-field
              label="E-mailadres"
              v-model="testEmail.emailaddress"
              prepend-icon="email"
              required
              :rules="[rules.email]"
              type="email"
            ></v-text-field>
          </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <div class="hogans-modal-footer clear">
            <v-btn class="modal-button-cancel" outline depressed color="#8B93A6" @click="testEmail.dialog = false">Annuleren</v-btn>
            <v-btn class="modal-button-next"  dark round :color="companyPrimaryColor" @click="sendTestmail()">Verzenden<v-icon right dark>arrow_forward_ios</v-icon></v-btn>
          </div>
        </v-card-actions>
      </v-card>

    </v-dialog>
      <!-- \ Test Email Dialog / -->
  </div>
</template>


<script>
import { bus } from "../main";
import db from "../firebase/init";
import platform from 'platform';
import moment from "moment"; 

export default {
  name: "ReviewSettings",

  data: () => ({
    loading: true,
    searchCompanies: "",
    testEmail: { 
      dialog: false,
      emailaddress: null,
      feedback: null,
      valid: false,
      language: null
    },
    feedback: null,
    activeCompData: {
      apiItems: {
        drupal: false,
        salonhub: false
      },
      social: {
        facebook: false,
        facebookUrl: null
      }
    },
    selectedLanguage: null,
    languages: [
      {
        code: "nl",
        name: "Nederlands"
      },
      {
        code: "en",
        name: "Engels"
      }
    ],

    activeCompDataOriginal: {},
    selected: [],
    companies: [],
    branches: [],
    activeComp: "",  
    rules: {
      email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || " E-mailadres is niet correct";
      }
    },
    minimumScore: [
      {
        label: "Slecht",
        score: 1
      },
      {
        label: "Onvoldoende",
        score: 2
      },
      {
        label: "Matig",
        score: 3
      },
      {
        label: "Voldoende",
        score: 4
      },
      {
        label: "Goed",
        score: 5
      },
    ],
    sendRestrictions: [
      {
        label: "4 weken",
        time: 4
      },
      {
        label: "6 weken",
        time: 6
      },
      {
        label: "8 weken",
        time: 8
      },
      {
        label: "10 weken",
        time: 10
      },
      {
        label: "13 weken",
        time: 13
      },
      {
        label: "26 weken",
        time: 26
      }
    ],
    responseRestrictions: [
      {
        label: "14 dagen",
        time: 14
      },
      {
        label: "21 dagen",
        time: 21
      },
      {
        label: "30 dagen",
        time: 30
      }
    ],
    questions: [],
    questionNumbers: [],
    activeJourney: {},
    selectedJourney: {},
    activeCompJourneys: {},
    selectedCustomerJourney: [],
    journeys: [],
    ratingSumData: [],
    dataChanged: false,
    questionsLeft: [],
    dataLeft: null,
    selectedJourneyId: null,
  }),

  created() {
    this.loadUserComp();
  },

  updated() {
    this.checkForUpdates();
  },

  methods: {
     loadUserComp() {
      this.loaded = false;
      let userCompanies = this.userCompanies;
      this.companies = [];
      let counter = 0

      new Promise((resolve, reject)=>{
        if(this.userRole == 'superadmin'){
          db.collection("companies")
          .get()
          .then(snap => {
            this.companies = [];
            snap.forEach(doc => {
              let company = doc.data();
              company.id = doc.id;
              this.companies.push(company);
            });
          })
          .then(()=>{
            resolve();
          })
        }
        else{
          this.userCompanies.forEach(company=>{
          db.collection("companies").doc(company).get()
            .then(doc => {
              let company = doc.data();
              company.id = doc.id;
              this.companies.push(company);
              counter++
              if(counter == this.userCompanies.length){
                resolve()
              }
            })
          })
        }
      })
      .then(()=>{
        // REMEMBER SELECTED COMPANY FROM LOCAL STORAGE
        if(this.userRole == 'superadmin'){
          // Super Admins have access to multiple companies 
          let selectedCompany = window.localStorage.getItem('selectedCompany')

          // Check if a selected company is set in the Local Storage
          if(selectedCompany){
            
            // Check if the selected company is an option
            let selectedCompanyIndex = _.findIndex(this.companies, { 'id': selectedCompany })

            // Selected company is an option, set activeComp
            if(selectedCompanyIndex >= 0){
              this.activeComp = this.companies[selectedCompanyIndex].id;
              this.loadActiveCompData();
            } 
            // Selected company is no option, set first company as activeComp 
            else{
              this.activeComp = this.companies[0].id;
              window.localStorage.setItem('selectedCompany', this.companies[0].id)
              this.loadActiveCompData();
            }
          }
          // No selected company is set 
          else {
            this.activeComp = this.companies[0].id;
            window.localStorage.setItem('selectedCompany', this.companies[0].id)
            this.loadActiveCompData();
          }
        }

        // Regular users have 1 company, just get the first
        else {
          this.activeComp = this.companies[0].id;
          this.loadActiveCompData();
        }
      })
    },

    loadActiveCompData() {
      this.loading = true;
      // Set Active Company as Selected Company in Local Storage
      window.localStorage.setItem('selectedCompany', this.activeComp)
      db.collection("companies")
        .doc(this.activeComp)
        .get()
        .then(doc => {
          if (doc.exists) {
            this.activeCompData = doc.data();
            this.activeCompData.id = doc.id;
          } else {
            console.log("No such document!");
          }
        })
        .then(() => {
          this.activeCompDataOriginal = _.cloneDeep(this.activeCompData);
          this.selectedLanguage = this.activeCompDataOriginal.languages[0]
        })
        .then(() => {
          this.loading = false;
          this.loadCompanyJourney();
          this.loadJourneys(); 
          this.loadQuestions();
        })
        .catch(error => {
          this.loading = false;
          console.log("Error getting document:", error);
        });
    },

    checkForUpdates() {
      if (this.questions.length > 0) {
      let dataChanged = false;
      let questionsLeft = [];
      this.questions.forEach(question => {
        if ((!question.answered && question.rating) || (!question.answered && question.feedback)) {
          // console.log("Vraag " + question.order + " is gewijzigd");
          dataChanged = true;
          questionsLeft.push(question.id);
        } else if (!question.answered) {
          // console.log("Vraag " + question.order + " is nog niet beantwoord");
          questionsLeft.push(question.id);
        } else if (question.answered) {
          // console.log("Vraag " + question.order + " is beantwoord");
        }
      });
      this.dataChanged = dataChanged;
      this.dataLeft = questionsLeft.length;
      this.questionsLeft = questionsLeft;
      }else {
        console.log("er zijn geen vragen")
      }
    },

    ratingSum() {
      this.ratingSumData = [];
      this.questions.forEach(element => {
        if (element.rating) {
          this.ratingSumData.push(Number(element.rating));
        } 
      });
    },

    loadCompanyJourney(){
      let journeyNumber = 0
      let activeJourneyId = null
        //  Kijken of er journeys zijn bij active comp

      if(_.isEmpty(this.activeCompData.journeys)) {
          // Nee -> Scenario 1 = het bedrijf heeft nog geen journey 
          console.log("Geen data gevonden bij company journeys: ", this.activeCompData.journeys)
          // Boodschap en link weergeven
          // ipv questions zeggen dat er geen questions zijn en een link naar de journey pagina 
      } else {
        console.log("Wel data gevonden bij company journeys: ", this.activeCompData.journeys)
        // Ja - > Kijken welke scenario van toepassing is
        // Kijken hoeveel items in de journey object zitten bij activeCompData
        if (_.size(this.activeCompData.journeys) >= 2) {
          console.log(" is meer dan 1 ");

       
          // _.hasIn(this.journeys, 'true')

          console.log("Kijken in Journey object")

          new Promise((resolve, reject)=>{
            let counter = 0           
             for (var key in this.activeCompData.journeys) {
              if(this.activeCompData.journeys[key] == true){
                activeJourneyId = key
              }
              counter++
              if(counter == _.size(this.activeCompData.journeys)){
                resolve()
              }
            }
          }) 
          .then(()=>{
            console.log("Resolved: ", activeJourneyId)
            if (activeJourneyId) {
              // met lodash kijken of er in een van de objects eentje is die true is. en dan die als selectedJourneyId selecteren.
              this.activeJourney = this.activeCompData; 
              console.log("er zijn meerdere journeys en een is actief")
              this.selectedJourneyId = activeJourneyId
              this.loadQuestions();
            }else{
              console.log("er zijn meedere journeys en geen een is actief")
              this.selectedJourney = Object.keys(this.activeCompData.journeys);
              this.selectedJourneyId = this.selectedJourney[0]
              this.loadQuestions();
              // ipv questions zeggen dat er geen questions zijn en een link naar de journey pagina 
            }
          })      
          

          
        }else {
          console.log(" is gelijk aan 1 ");
          // && this.activeCompData.journeys == true
           // Deze selecteren als selectedJourney en de vragen ophalen
          if (this.activeCompData.active == true) {
            this.activeJourney = this.activeCompData; 
            this.selectedJourney = Object.keys(this.activeCompData.journeys);
            this.selectedJourneyId = this.selectedJourney[0]
            console.log(Object.keys(this.activeCompData.journeys));
            console.log("er is 1 journey en die is actief")
            this.loadQuestions();
          }else{
            // _.findIndex(this.activeCompData, { 'journeys': fasle })
            console.log("er is 1 journey en die is niet actief")
             this.selectedJourneyId = this.selectedJourney[0];
            // ipv questions zeggen dat er geen questions zijn en een link naar de journey pagina 
          }
        }
      
      }
    },

    loadJourneys() {
      console.log("active journey functie word aangeroepen");
      db.collection("journeys")
        .where(`companies.${this.activeComp}`, "==", true)
        .get()
        .then(snap => {
          this.journeys = [];
          snap.forEach(doc => {
            let journey = doc.data();
            this.stages = [];
            journey.id = doc.id;
            this.journeys.push(journey);
          });
        })
    },

    loadQuestions() {
      // QUESTIONS
      // eerste keer de eerste pakken
      // tweede keer de aangeclickte journey id meegeven 
      // console.log("de journey id =", this.selectedJourneyId);
      db.collection("questions")
      .where("journeyId", "==", this.selectedJourneyId)
      .get()
      .then(snap => {
        this.questionNumbers = [];
        this.questions = [];
        snap.forEach(doc => {
          if (doc.data()) {
            let question = doc.data();
            question.id = doc.id;
            this.questions.push(question);
          }
        });
      })
      .then(() => {
        if (this.questions.length > 0) {
          this.questions.sort(this.sortQuestions);
           this.questions[0].rating = 1;
          console.log("er zijn questions");
        }
      })
    },

    sortQuestions(a, b) {
      // Use toUpperCase() to ignore character casing
      const genreA = a.order;
      const genreB = b.order;

      let comparison = 0;
      if (genreA > genreB) {
        comparison = 1;
      } else if (genreA < genreB) {
        comparison = -1;
      }
      return comparison;
    },
    
    updateCompanyEmail() {
      db.collection("companies")
        .doc(this.activeComp)
        .update({
          emailSubject: this.activeCompData.emailSubject,
          emailIntro: this.activeCompData.emailIntro
        })
        .then(() => {
          db.collection("log").add({
            time: new Date(),
            logType: "info",
            user: this.userFirstName + " " + this.userLastName,
            userType: this.userRole,
            company: this.userCompany,
            actionType: "User Action",
            software: String(platform.os),
            browser: platform.name + ' ' + platform.version, 
            pillarrrVersion: this.$store.state.version,
            action: "Survey Email aangepast: " + this.activeCompData.name,
            extra:
              "<b>ORIGINELE GEGEVENS:</b> " +
              "<br>" +
              "<b>Onderwerp:</b> " +
              "NL: " +
              this.activeCompDataOriginal.emailSubject.nl +
              "<br>" +
              "EN: " +
              this.activeCompDataOriginal.emailSubject.en +
              "<br>" +
              "<b>Email intro:</b><br> " +
              "NL: " +
              this.activeCompDataOriginal.emailIntro.nl +
              "<br>" +
              "EN: " +
              this.activeCompDataOriginal.emailIntro.en +
              "<br><br>" +
              "<b>AANGEPAST GEGEVENS:</b> " +
              "<br>" +
              "<b>Onderwerp:</b> " +
              "NL: " +
              this.activeCompData.emailSubject.nl +
              "<br>" +
              "EN: " +
              this.activeCompData.emailSubject.en +
              "<br>" +
              "<b>Email intro:</b><br> " +
              "NL: " +
              this.activeCompData.emailIntro.nl +
              "<br>" +
              "EN: " +
              this.activeCompData.emailIntro.en
          });
        })
        .then(() => {
          this.loadActiveCompData();
        })
        .catch(() => {
          console.error("Error updating document: ", error);
        });
    },

    updateCompanySettings() {
      db.collection("companies")
        .doc(this.activeComp)
        .set({
          email: this.activeCompData.email,
          url: this.activeCompData.url,
          ratingView: this.activeCompData.ratingView,
          sendRestriction: this.activeCompData.sendRestriction,
          sendRestrictionTime: this.activeCompData.sendRestrictionTime,
          surveyResponseTime: this.activeCompData.surveyResponseTime,
          directFeedback: this.activeCompData.directFeedback,
          directFeedbackScore: this.activeCompData.directFeedbackScore,
          directFeedbackMailTo: this.activeCompData.directFeedbackMailTo,
          directFeedbackMailFrom: this.activeCompData.directFeedbackMailFrom,
          surveyFeedbackAsk: this.activeCompData.surveyFeedbackAsk,
          receipt: {
            sendReceipt: this.activeCompData.receipt.sendReceipt,
            sendReceiptJourney: this.activeCompData.receipt.sendReceiptJourney
          }
        }, { merge: true })
        .then(() => {
          db.collection("log")
            .add({
              time: new Date(),
              logType: "info",
              user: this.userFirstName + " " + this.userLastName,
              userType: this.userRole,
              company: this.userCompany,
              actionType: "User Action",
              software: String(platform.os),
              browser: platform.name + ' ' + platform.version, 
              pillarrrVersion: this.$store.state.version,
              action: "Algemene instellingen gewijzigd: " + this.activeCompData.name,
              extra:
                "<b>ORGINELE GEGEVENS:</b><br>" +
                "<b>E-mailadres:</b> " +
                this.activeCompDataOriginal.email +
                "<br>" +
                "<b>Website URL:</b> " +
                this.activeCompDataOriginal.url +
                "<br>" +
                "<b>Minimale periode tussen 2 surveys:</b> " +
                this.activeCompDataOriginal.sendRestriction +
                "<br>" +
                "<b>Lengte minimale periode:</b> " +
                this.activeCompDataOriginal.sendRestrictionTime +
                " weken <br>" +
                "<b>Beoordelingsweergave:</b> " +
                this.activeCompDataOriginal.ratingView +
                "<br><br>" +
                "<b>AANGEPASTE GEGEVENS:</b><br>" +
                "<b>E-mailadres:</b> " +
                this.activeCompData.email +
                "<br>" +
                "<b>Website URL:</b> " +
                this.activeCompData.url +
                "<br>" +
                "<b>Minimale periode tussen 2 surveys:</b> " +
                this.activeCompData.sendRestriction +
                "<br>" +
                "<b>Lengte minimale periode:</b> " +
                this.activeCompData.sendRestrictionTime +
                " weken <br>" +
                "<b>Beoordelingsweergave:</b> " +
                this.activeCompData.ratingView
            })
            .catch(error => {
              console.error("Error logging new branch: ", error);
            });
        })
        .then(() => {
          this.loadActiveCompData();
        })
        .catch(() => {
          console.error("Error updating document: ", error);
        });
    },

    updateCompanySurveyPage() {
      db.collection("companies")
        .doc(this.activeComp)
        .update({
          pageIntro: this.activeCompData.pageIntro,
          pageAspects: this.activeCompData.pageAspects
        })
        .then(() => {
          db.collection("log").add({
            time: new Date(),
            user: this.userFirstName + " " + this.userLastName,
            userType: this.userRole,
            company: this.userCompany,
            actionType: "User Action",
            software: String(platform.os),
            browser: platform.name + ' ' + platform.version, 
            pillarrrVersion: this.$store.state.version,
            action: "Survey Pagina aangepast: " + this.activeCompData.name,
            extra:
              "<b>ORIGINELE GEGEVENS:</b> " +
              "<br>" +
              "<b>Bedankt tekst:</b><br> " +
              "NL: " +
              this.activeCompDataOriginal.pageIntro.nl +
              "<br>" +
              "EN: " +
              this.activeCompDataOriginal.pageIntro.en +
              "<br>" +
              "<b>Tekst andere aspecten:</b><br> " +
              "NL: " +
              this.activeCompDataOriginal.pageAspects.nl +
              "<br>" +
              "EN: " +
              this.activeCompDataOriginal.pageAspects.en +
              "<br><br>" +
              "<b>AANGEPAST GEGEVENS:</b> " +
              "<br>" +
              "<b>Bedankt tekst:</b><br> " +
              "NL: " +
              this.activeCompData.pageIntro.nl +
              "<br>" +
              "EN: " +
              this.activeCompData.pageIntro.en +
              "<br>" +
              "<b>Tekst andere aspecten:</b><br> " +
              "NL: " +
              this.activeCompData.pageAspects.nl +
              "<br>" +
              "EN: " +
              this.activeCompData.pageAspects.en
          });
        })
        .then(() => {
          this.loadActiveCompData();
        })
        .catch(() => {
          console.error("Error updating document: ", error);
        });
    },

    openTestmailDialog(){
      this.testEmail.language =  this.activeCompData.languages[0]
      this.testEmail.dialog =  true
    },

    // testEmail: { 
    //   dialog: false,
    //   emailaddress: null,
    //   feedback: null,
    //   valid: false
    // },

    add(a, b) {
      return a + b;
    },

    sendTestmail(){
      this.testEmail.feedback = null
      if (this.$refs.testmail.validate()) {
          db.collection('mail').add({
            to: this.testEmail.emailaddress,
            message: {
              subject: this.activeCompData.emailSubject[this.testEmail.language],
              html: this.activeCompData.emailIntro[this.testEmail.language],
            },
          })
          .then(()=>{
            this.testEmail.dialog =  false
          })
        
      } else {
        this.testEmail.feedback = "Vul een geldig emailadres in.";
      }
    }
  },

  computed: {
    reviewsPackage(){
      let packageStatus = { 
        type: 'inactive',
        days: 0
      }

      if(this.activeCompData.packages && this.activeCompData.packages.length > 0 && _.indexOf(this.activeCompData.packages, 'customerjourney') >= 0){
        packageStatus.type = 'active';
      }
      else{
        // Package not purchased, check for active trial
        if(this.activeCompData.trials && this.activeCompData.trials.length > 0){
          this.activeCompData.trials.forEach(trailPackage =>{
            if(trailPackage.id == 'customerjourney'){
              // Trial found, check if trialperiod is still active
              if(moment(trailPackage.trialStartDate).add(trailPackage.trialDays, 'days') > moment()){
                packageStatus.type = 'trial';
                packageStatus.days = moment(trailPackage.trialStartDate).add(trailPackage.trialDays, 'days').diff(moment(), 'days')
              }
            }
          })
        }
      }
      return packageStatus
    },

    demoMode(){
      return this.$store.state.demoMode;
    },
    
    userCompanies() {
      return this.$store.state.userCompanies;
    },
    userCompany() {
      return this.$store.state.userCompany;
    },
    userFirstName() {
      return this.$store.state.userFirstName;
    },
    userLastName() {
      return this.$store.state.userLastName;
    },
    userRole() {
      return this.$store.state.userRole;
    },
    companyPrimaryColor() {
      return this.$store.state.companyPrimaryColor;
    },
    companySecondaryColor() {
      return this.$store.state.companySecondaryColor;
    },
    companyNarrowcasting() {
      if (_.includes(this.activeCompData.packages, "narrowcasting")) {
        return true;
      } else {
        return false;
      }
    },
    companyJourney() {
      if (_.includes(this.activeCompData.packages, "customerjourney")) {
        return true;
      } else {
        return false;
      }
    },
    changed() {
      if (_.isEqual(this.activeCompData, this.activeCompDataOriginal) == false) {
        return true;
      } else {
        return false;
      }
    },
    filteredCompanies(){
      if(this.searchCompanies && this.searchCompanies.length > 0){
        return this.companies.filter(company => {
          return company.name.toLowerCase().includes(this.searchCompanies.toLowerCase());
        });
      } else {
        return this.companies
      }
    },
    theme(){
      return (this.$vuetify.theme.dark) ? 'dark' : 'light'
    },
    averageScore() {
      if (this.ratingSumData.length > 0) {
        let givenRatings = this.ratingSumData.reduce(this.add, 0);
        let avarageScore;
        avarageScore = ((givenRatings * 2) / this.ratingSumData.length).toFixed(1);
        return avarageScore;
      } else {
        return 2;
      }
    }
  }
};
</script>

<style>
.send-survey-button-page-preview {
  right: 300px;
  bottom: 50px;
}

.custom-table ul {
  padding: 5px 0;
  list-style: square;
}

.custom-table li{
  display: list-item;
}
@import "~vue-wysiwyg/dist/vueWysiwyg.css";
p.settings-tab-introtext {
  padding: 10px 0 0 0;
  font-size: 16px;
}

.email-preview {
  padding: 20px 0;
  background-color: #f6f7fb;
}

.email-wrapper {
  width: 560px;
  margin: 20px auto;
  padding: 20px;
  background: #ffffff;
  border: 1px solid #e8e9ee;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.04);
  border-radius: 5px;
}

/* EMAIL TEMPLATE  */

.email-logo {
  width: 180px;
  height: 180px;
  margin: 20px auto 0 auto;
  overflow: hidden;
}

.email-wrapper h2 {
  text-align: center;
  padding: 20px 0;
  font-size: 16px;
  font-weight: bold;
}

.email-logo img {
  width: 100%;
  height: auto;
}

.email-buttons {
  padding: 10px 20px;
}

.survey-wrapper .editr--content {
  min-height: 80px;
}

.email-wrapper .editr--content {
  min-height: 100px;
}

.social-preview-wrapper p {
  text-align: center;
}

.social-preview-wrapper p a.social-icon-preview {
  display: inline-block;
  width: 40px;
  height: 40px;
  margin: 5px;
}

.social-preview-wrapper p a.social-icon-preview:hover {
  cursor: pointer;
}

.email-wrapper .rating-preview-wrapper {
  width: 518px;
  border: 1px solid #e6e6e6;
  border-radius: 5px;
  margin: 20px 0;
}

.email-wrapper .rating-preview-wrapper:hover {
  cursor: pointer;
}
.email-wrapper .rating-preview-wrapper h2 {
  text-align: center;
  padding: 10px 0;
  font-size: 16px;
  font-weight: bold;
}

.rating-preview-smileys .preview-smiley {
  float: left;
  width: 93px;
  height: 90px;
  margin: 5px;
}

.rating-preview-smileys .preview-smiley.smiley-one {
  background: url("../assets/rating-icons/rating-icon-slecht.png") no-repeat center center;
  background-size: 93px auto;
}
.rating-preview-smileys .preview-smiley.smiley-two {
  background: url("../assets/rating-icons/rating-icon-onvoldoende.png") no-repeat center center;
  background-size: 93px auto;
}
.rating-preview-smileys .preview-smiley.smiley-three {
  background: url("../assets/rating-icons/rating-icon-voldoende.png") no-repeat center center;
  background-size: 93px auto;
}
.rating-preview-smileys .preview-smiley.smiley-four {
  background: url("../assets/rating-icons/rating-icon-goed.png") no-repeat center center;
  background-size: 93px auto;
}
.rating-preview-smileys .preview-smiley.smiley-five {
  background: url("../assets/rating-icons/rating-icon-super.png") no-repeat center center;
  background-size: 93px auto;
}

.rating-preview-stars .preview-star {
  float: left;
  width: 93px;
  height: 90px;
  margin: 5px;
}

.rating-preview-stars .preview-star.star-one {
  background: url("../assets/rating-icons/rating-star-1-active.png") no-repeat center center;
  background-size: 93px auto;
}
.rating-preview-stars .preview-star.star-two {
  background: url("../assets/rating-icons/rating-star-2-active.png") no-repeat center center;
  background-size: 93px auto;
}
.rating-preview-stars .preview-star.star-three {
  background: url("../assets/rating-icons/rating-star-3-active.png") no-repeat center center;
  background-size: 93px auto;
}

.rating-preview-stars .preview-star.star-four {
  background: url("../assets/rating-icons/rating-star-4-active.png") no-repeat center center;
  background-size: 93px auto;
}
.rating-preview-stars .preview-star.star-five {
  background: url("../assets/rating-icons/rating-star-5-active.png") no-repeat center center;
  background-size: 93px auto;
}

.social-preview-wrapper p a.social-icon-preview.facebook {
  background: url("../assets/social/facebook-logo.png") no-repeat center center;
  background-size: 40px;
}
.social-preview-wrapper p a.social-icon-preview.instagram {
  background: url("../assets/social/instagram-logo.png") no-repeat center center;
  background-size: 40px;
}
.social-preview-wrapper p a.social-icon-preview.pinterest {
  background: url("../assets/social/pinterest-logo.png") no-repeat center center;
  background-size: 40px;
}
.social-preview-wrapper p a.social-icon-preview.twitter {
  background: url("../assets/social/twitter-logo.png") no-repeat center center;
  background-size: 40px;
}
.social-preview-wrapper p a.social-icon-preview.googleplus {
  background: url("../assets/social/google-plus-logo.png") no-repeat center center;
  background-size: 40px;
}

.preview-footer p {
  text-align: center;
  font-size: 12px;
  color: #838385;
  padding: 10px 0 0 0;
}
.tabs-component-panel {
  position: relative;
}
.test-mail-wrapper {
  position: absolute;
  right: 20px;
  top: 20px;
}

.test-mail-wrapper button {
  color: white;
  padding: 13px 15px 13px 40px;
  font-size: 14px;
  line-height: 16px;
  border-radius: 5px;
  text-transform: uppercase;
  background: #e5007d url("../assets/icons/send-icon-white.svg") no-repeat left 10px center;
  background-size: 20px auto;
  font-weight: 600;
}

.test-mail-wrapper button:hover,
.test-mail-wrapper button:active {
  background: #4a148c url("../assets/icons/send-icon-white.svg") no-repeat left 10px center;
  background-size: 20px auto;
  color: #fff;
  cursor: pointer;
}

.user-permissions-table {
  padding: 3px 0;
}

.user-permissions-table p {
  padding: 3px 0 0 0;
  margin: 0;
  font-weight: 600;
  font-size: 12px;
}

.user-permissions-table ul {
  padding: 0 0 0 14px;
}

.user-permissions-table ul li {
  font-size: 12px;
}

.tab-inner-wrapper.padding {
  padding: 20px;
  position: relative;
}

.tab-header.table {
  padding: 20px 20px 0 20px;
}

.first-item-button {
  padding: 100px 0;
}
</style>